import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-074b1fd0")

_pushScopeId("data-v-074b1fd0")
const _hoisted_1 = { class: "reportConfirm_reportContent" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_config = _resolveComponent("config")
  const _component_paint = _resolveComponent("paint")
  const _component_ecu = _resolveComponent("ecu")
  const _component_detect = _resolveComponent("detect")
  const _component_anotherDetect = _resolveComponent("anotherDetect")
  const _component_remark = _resolveComponent("remark")
  const _component_batteryInfo = _resolveComponent("batteryInfo")
  const _component_procedures = _resolveComponent("procedures")
  const _component_carPhotoList = _resolveComponent("carPhotoList")
  const _component_markPhoto = _resolveComponent("markPhoto")
  const _component_detectVideo = _resolveComponent("detectVideo")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (_ctx.state.configureInfos && _ctx.state.configureInfos.checkItemVOList.length>0)
      ? (_openBlock(), _createBlock(_component_config, {
          key: 0,
          renderData: _ctx.state.configureInfos
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.paintCheck && JSON.stringify(_ctx.state.paintCheck) !== "{}")
      ? (_openBlock(), _createBlock(_component_paint, {
          key: 1,
          renderData: _ctx.state.paintCheck
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.ecuInfo && _ctx.state.ecuInfo >=0)
      ? (_openBlock(), _createBlock(_component_ecu, {
          key: 2,
          renderData: _ctx.state.ecuInfo
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.checkInfo && JSON.stringify(_ctx.state.checkInfo) !== "{}")
      ? (_openBlock(), _createBlock(_component_detect, {
          key: 3,
          renderData: _ctx.state.checkInfo
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.defectPhotoList && _ctx.state.defectPhotoList.length>0)
      ? (_openBlock(), _createBlock(_component_anotherDetect, {
          key: 4,
          renderData: _ctx.state.defectPhotoList
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.reportData && JSON.stringify(_ctx.reportData) !== "{}")
      ? (_openBlock(), _createBlock(_component_remark, {
          key: 5,
          renderData: _ctx.reportData
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.battery.batteryDetect || _ctx.state.battery.batterySOH)
      ? (_openBlock(), _createBlock(_component_batteryInfo, {
          key: 6,
          renderData: _ctx.state.battery
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.procedurePhotoList && _ctx.state.procedurePhotoList.length>0)
      ? (_openBlock(), _createBlock(_component_procedures, {
          key: 7,
          renderData: _ctx.state.procedurePhotoList
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.photoList && _ctx.state.photoList.length>0)
      ? (_openBlock(), _createBlock(_component_carPhotoList, {
          key: 8,
          renderData: _ctx.state.photoList
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.markPhotoList && _ctx.state.markPhotoList.length>0)
      ? (_openBlock(), _createBlock(_component_markPhoto, {
          key: 9,
          renderData: _ctx.state.markPhotoList
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true),
    (_ctx.state.videoList && _ctx.state.videoList.length>0)
      ? (_openBlock(), _createBlock(_component_detectVideo, {
          key: 10,
          renderData: _ctx.state.videoList
        }, null, 8, ["renderData"]))
      : _createCommentVNode("", true)
  ]))
})